/**
 * @public
 */
export var Clone;
(function (Clone) {
    function clone(value) {
        return value.clone();
    }
    Clone.clone = clone;
})(Clone || (Clone = {}));
//# sourceMappingURL=clone.js.map